import script from "./PolymersSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./PolymersSearch.vue?vue&type=script&setup=true&lang=ts"

import "./PolymersSearch.vue?vue&type=style&index=0&id=1b754776&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b754776"]])

export default __exports__